// Canonical account memberships only. Assignment never grants CRM access.
export function crmMemberExclusion(member, workspaceUid) {
  if (!member?.uid || member.uid !== member.id || (member.workspaceUid && member.workspaceUid !== workspaceUid)) return "Membership identity does not match this workspace.";
  if (member.status !== "active" || member.isActive === false) return "Membership is not active.";
  if (!["owner", "admin", "super_admin"].includes(member.role) &&
      !["crm", "manageCrm", "crmManage"].some(key => member.permissions?.[key] === true)) return "CRM access is disabled.";
  return "";
}

export function buildCrmMemberRoster(documents, workspaceUid) {
  return documents.map(member => ({ ...member,
    name: member.name || member.displayName || member.email || "Team member",
    exclusionReason: crmMemberExclusion(member, workspaceUid),
  }));
}
